import { render, staticRenderFns } from "./ModelPreview.vue?vue&type=template&id=6aa0f268&scoped=true&"
import script from "./ModelPreview.vue?vue&type=script&lang=js&"
export * from "./ModelPreview.vue?vue&type=script&lang=js&"
import style0 from "./ModelPreview.vue?vue&type=style&index=0&id=6aa0f268&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0f268",
  null
  
)

export default component.exports